// src/utils/seo.ts

interface SEOParams {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  canonical?: string;
  locale?: string;
}

export const generateSEOTags = (params: SEOParams, language: 'fr' | 'en' = 'fr') => {
  const baseUrl = 'https://cliniquemainsdoucesplus.com';
  const defaultImage = `${baseUrl}/og-image.jpg`;
  
  const seoData = {
    title: `${params.title} | Clinique Mains Douces Plus Simbock`,
    description: params.description,
    keywords: params.keywords || 'clinique simbock, centre médical tradex, yaoundé santé',
    ogImage: params.ogImage || defaultImage,
    canonical: params.canonical || baseUrl,
    locale: params.locale || (language === 'fr' ? 'fr_FR' : 'en_US')
  };
  
  return seoData;
};

// Location-specific keywords
export const locationKeywords = {
  simbock: [
    'clinique Simbock',
    'centre médical Simbock',
    'médecin Simbock',
    'hôpital Simbock',
    'urgences Simbock',
    'Tradex Simbock santé',
    'cabinet médical Simbock',
    'docteur Simbock',
    'pharmacie Simbock',
    'laboratoire Simbock'
  ],
  yaounde: [
    'clinique Yaoundé',
    'centre médical Yaoundé',
    'santé Yaoundé',
    'hôpital Yaoundé'
  ],
  services: [
    'consultation générale',
    'pédiatrie Simbock',
    'maternité Simbock',
    'gynécologie',
    'échographie',
    'vaccination',
    'analyse médicale'
  ]
};

// Structured data for specific pages
export const getStructuredData = (page: string) => {
  const baseData = {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "Clinique Mains Douces Plus",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Tradex Simbock",
      "addressLocality": "Simbock, Yaoundé",
      "addressCountry": "CM"
    }
  };
  
  const pageSpecificData: Record<string, any> = {
    home: {
      ...baseData,
      "description": "Centre médical de référence à Simbock, Yaoundé"
    },
    services: {
      ...baseData,
      "description": "Services médicaux complets à Simbock"
    },
    contact: {
      ...baseData,
      "description": "Contactez notre clinique à Tradex Simbock"
    }
  };
  
  return pageSpecificData[page] || baseData;
};